import { ErrorLayout } from '@uag/react-core';

export const NotFound = () => {
    return <ErrorLayout description="Page not found!" title="404"/>;
};
